import { type RefObject, useLayoutEffect, useRef } from 'react';
import { Container, Content } from './BottomNavbar.styles';

/** Read by the audio status bar, which stacks above the bottom bar instead of covering it. */
export const BOTTOM_NAVBAR_HEIGHT_VARIABLE = '--bottom-navbar-height';

export function usePublishBottomNavbarHeight(ref: RefObject<HTMLElement | null>) {
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return undefined;
    const root = document.documentElement;
    const publishHeight = () =>
      root.style.setProperty(BOTTOM_NAVBAR_HEIGHT_VARIABLE, `${element.offsetHeight}px`);
    publishHeight();
    const observer = new ResizeObserver(publishHeight);
    observer.observe(element);
    return () => {
      observer.disconnect();
      root.style.removeProperty(BOTTOM_NAVBAR_HEIGHT_VARIABLE);
    };
  }, [ref]);
}

interface BottomNavbarProps {
  children: React.ReactNode;
}

export function BottomNavbar({ children }: BottomNavbarProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  usePublishBottomNavbarHeight(containerRef);

  return (
    <Container ref={containerRef}>
      <Content>{children}</Content>
    </Container>
  );
}
